export const SHOW_ALL_OPTION = { id: '', name: 'Show All' }; 